module.exports = __webpack_public_path__ + "assets/img/mobile_1.50436cc3.svg";